import styled from 'styled-components';

import MoreCard from '@klaviyo-mkt/gatsby-components/molecules/more-card';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';
import Grid from '@klaviyo-mkt/gatsby-components/utils/grid';
import Icon from '@klv/atoms/icon';

export const SiteWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightSand};
`;

export const SearchWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  padding: 5.6rem 0;
`;

export const KlaviyoFlag = styled(Icon)`
  fill: ${({ theme }) => theme.colors.poppy};
  margin-bottom: 1.6rem;
  font-size: 2.5rem;
`;

export const SearchHeadline = styled(Typography)`
  text-align: center;
  margin-bottom: 2rem;
`;

export const PageFooter = styled(Grid)`
  display: block;
  margin-top: 5.2rem;
  margin-bottom: 3.2rem;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      margin-top: 4rem;
      margin-bottom: 5.6rem;
    }
  `}
`;

export const PageFooterText = styled(Typography)``;

export const MoreCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding: 3.2rem 0;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      flex-direction: row;
      padding: 4.8rem 0;
    }
  `}
`;

export const StyledMoreCard = styled(MoreCard)`
  height: auto;
`;
